import './bootstrap';

// Metronic
import './metronic';

// App
Object.defineProperty(window, 'App', {
    configurable: false,
    writable: false,
    value: (() => {
        let locale = null;

        return {
            get locale() {
                return locale;
            },

            set locale(value) {
                locale = value;
                Lang.setLocale(locale);
                Lang.setMessages(App.lang);
                Validator.setLocale(locale);
                Validator.setMessages(locale, App.lang[locale].short.validation);
            },

            configure(options) {
                Object.assign(this, options);
            },
        };
    })(),
});

// App code
if (window.location.pathname.startsWith('/admin')) {
    Alpine.data('UserDetails', () => ({
        init() {
            this.$root.classList.add('user-details-link');
        },

        show(userId) {
            abmodal({
                title: __('User Details'),
                message: document.getElementById('user_details_modal').innerHTML,
                backdrop: true,
                closeButton: true,
                onEscape: true,
                size: 'large',
                buttons: {
                    close: {
                        label: __('Close'),
                    },
                },
                data: {
                    loaded: false,
                    user: null,

                    async init() {
                        this.user = await zcache.rememberAsync('user-' + userId, 60, async () => {
                            const response = await axios.get(zroute('/admin/users/{user}', { user: userId }));

                            return response.data;
                        });

                        this.loaded = true;
                    },
                },
            });
        },
    }));
}

// Init code
Bolt.once('load', (event) => {
    if ('serviceWorker' in navigator) {
        if (App.serviceWorker.enabled) {
            navigator.serviceWorker.register(App.serviceWorker.url, { scope: '/' }).then(
                (registration) => registration.active?.postMessage('ACTIVATE'),
                () => {}
            );
        }

        if (App.serviceWorker.unregister) {
            navigator.serviceWorker.getRegistrations().then((registrations) => registrations.forEach((registration) => registration.unregister()));
        }
    }
});

Bolt.once('unload', (event) => {
    document.head.querySelectorAll('style').forEach((style) => {
        if (!style.hasAttribute('bolt-pin') && style.innerHTML.includes('url(/cf-fonts/')) {
            style.removeAttribute('bolt-transient');
            style.setAttribute('bolt-pin', '');
        }
    });
});

Bolt.on('unload', (event) => {
    delete document.body.dataset.offcanvasAside;

    KTUtil.data(document.querySelector('#kt_aside_menu')).get('ps')?.destroy();

    $('.modal').modal('hide');
    $('.tooltip').tooltip('dispose');
    $('.popover').popover('dispose');
});

let oldScrollTop = 0;

Bolt.on('before-render', (event) => {
    const { oldDocument, newDocument } = event.detail;
    const checkedClass = 'aside-minimize-hover';

    if (oldDocument.body.classList.contains(checkedClass)) {
        newDocument.body.classList.add(checkedClass);
    }

    oldScrollTop = oldDocument.getElementById('kt_aside_menu')?.scrollTop || 0;
});

Bolt.on('load', (event) => {
    const menu = document.getElementById('kt_aside_menu');

    if (menu) {
        menu.scrollTop = oldScrollTop;
    }
});

window.addEventListener('mouseover', (event) => {
    window._mouseCoords = { x: event.clientX, y: event.clientY };
});

Bolt.on('load', (event) => {
    if (App.notification) {
        Helper.showNotification(...Object.values(App.notification));
    }
});

Bolt.setTargetSelectors('#app-container');
Bolt.start();
